var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceClicked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 0.895431 0 2 0H12L19 7V22C19 23.1046 18.1046 24 17 24H2C0.895431 24 0 23.1046 0 22V2ZM16 6L12 2V6H16ZM13.3438 13.2812L13.7344 11.8359H12.1753C12.1061 11.3859 11.967 10.9849 11.7578 10.6328C11.7206 10.5684 11.681 10.5059 11.6392 10.4453H13.3438L13.7422 9H6.45312L6.00781 10.6953H8.05469C8.54427 10.6953 8.9375 10.7786 9.23438 10.9453C9.53125 11.112 9.7474 11.3438 9.88281 11.6406C9.91208 11.7037 9.93818 11.7688 9.96113 11.8359H6.39844L6 13.2812H9.9998C9.9641 13.4038 9.91729 13.521 9.85938 13.6328C9.71354 13.9245 9.49219 14.1562 9.19531 14.3281C8.90365 14.4948 8.53125 14.5781 8.07812 14.5781H6.21875L6.22656 15.8281L10.0781 20.375H12.4609V20.2656L8.96875 16.1016C9.75 15.9974 10.3802 15.7891 10.8594 15.4766C11.3385 15.1641 11.6849 14.7604 11.8984 14.2656C12.03 13.9648 12.122 13.6367 12.1745 13.2812H13.3438Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceClicked);
export default __webpack_public_path__ + "static/media/InvoiceClicked.a4450d2a1a9ef306c42d792f37453a60.svg";
export { ForwardRef as ReactComponent };